import { EMPTY_LIST } from '../../../../../constants/common'
import { getItemsFromApiResponse } from '../../../../../utils/api'

function updateChecklistItems(checklists, checklistId, updater) {
  return checklists.map(checklist =>
    checklist.id === checklistId
      ? { ...checklist, items: updater(checklist.items) }
      : checklist
  )
}

export function getChecklistWithItems(checklist, itemsResponse) {
  return {
    ...checklist,
    items: getItemsFromApiResponse(itemsResponse) || EMPTY_LIST,
  }
}

export function getChecklistsWithItems(checklists, itemsResponses) {
  return checklists.map((checklist, index) =>
    getChecklistWithItems(checklist, itemsResponses[index])
  )
}

export function addChecklistItem(checklists, checklistId, checklistItem) {
  return updateChecklistItems(checklists, checklistId, checklistItems => [
    ...checklistItems,
    checklistItem,
  ])
}

export function replaceChecklistItem(checklists, checklistId, checklistItem) {
  return updateChecklistItems(checklists, checklistId, checklistItems =>
    checklistItems.map(item =>
      item.id === checklistItem.id ? checklistItem : item
    )
  )
}

export function removeChecklistItem(checklists, checklistId, checklistItemId) {
  return updateChecklistItems(checklists, checklistId, checklistItems =>
    checklistItems.filter(checklistItem => checklistItem.id !== checklistItemId)
  )
}
